import {Col} from 'react-bootstrap'
import {useFormik} from 'formik'
import {IinvoiceCreateForm, initInvoiceCreateFormValues} from '../core/_model'
import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import FlatPickrDateTime from '../../../utils/components/FlatPickrDateTime'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'
import {KTCard, KTCardBody, KTIcon} from '../../../../_metronic/helpers'
import * as Yup from 'yup'
import {BASE_URL} from '../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import toast from 'react-hot-toast'
import FlatPickrDate from '../../../utils/components/FlatPickrDate'
import {useNavigate} from 'react-router-dom'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'
import {Helmet} from 'react-helmet-async'

const CREATE_INVOICE_URL = `${BASE_URL}/api/protect/createInvoice`

const invoiceSchema = Yup.object().shape({
  username: Yup.string().required('Username is required'),
  startTime: Yup.string().required('Start time is required'),
  endTime: Yup.string().required('End time is required'),
})

const InvoiceCreate = () => {
  const queryClient = useQueryClient()
  const {userInfo} = useRittApp()
  const navigate = useNavigate()

  const {mutateAsync: submitInvoice} = useMutation({
    mutationFn: async (sendvalues: Partial<IinvoiceCreateForm>) => {
      const values = {
        userId: sendvalues.userId,
        sdate: sendvalues.startTime,
        edate: sendvalues.endTime,
      }
      const response = await axios.post(CREATE_INVOICE_URL, values)
      console.log(response)
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfull')
      resetForm()
      queryClient.invalidateQueries(['invoiceList'])
      navigate('/billing/invoice/list')
    },
    onError: (error) => {
      toast.dismiss()
      console.log(error)
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: initInvoiceCreateFormValues,
    validationSchema: invoiceSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        console.log(values)
        await submitInvoice(values)
      } catch (error) {
        // toast.dismiss()
        console.log(error)
      }
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  const onSelectUser = (id: number) => formik.setFieldValue('userId', id)

  return (
    <KTCard>
      <KTCardBody>
        <Helmet>
          <title>Invoice Create</title>
        </Helmet>
        <h3 className='fs-1 text-gray-800 mb-10'>Create Invoice</h3>
        <form onSubmit={formik.handleSubmit} className='w-100 mw-500px'>
          <Col>
            <label className='col-form-label fs-6'>
              <span className='required'>Select User</span>
            </label>
            <OptimizedSelectBox
              formik={formik}
              fieldValue='username'
              placeholder='Select user'
              setSelect={onSelectUser}
              options={userInfo}
            />

            {formik.touched.username && formik.errors.username && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.username}</span>
                </div>
              </div>
            )}
          </Col>
          <Col>
            <label className='col-form-label fs-6'>
              <span className='required'>Start Time</span>
            </label>

            {/* <FlatPickrDateTime formik={formik} fieldName='startTime' /> */}

            <div id='startTime' className=''>
              <FlatPickrDate
                placeholder='Select start time'
                fieldName='startTime'
                formik={formik}
                container='startTime'
              />
            </div>

            {formik.touched.startTime && formik.errors.startTime && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.startTime}</span>
                </div>
              </div>
            )}
          </Col>
          <Col>
            <label className='col-form-label fs-6'>
              <span className='required'>End Time</span>
            </label>

            {/* <FlatPickrDateTime formik={formik} fieldName='endTime' /> */}

            <div id='endTime' className=''>
              <FlatPickrDate
                placeholder='Start end time'
                fieldName='endTime'
                formik={formik}
                container='endTime'
              />
            </div>

            {formik.touched.endTime && formik.errors.endTime && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.endTime}</span>
                </div>
              </div>
            )}
          </Col>
          <div className='pt-15'>
            <button
              type='reset'
              className='btn btn-light me-3 border border-gray-600'
              data-kt-users-modal-action='cancel'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={resetForm}
            >
              CLOSE
            </button>

            <button
              type='submit'
              className='btn btn-primary me-3'
              data-kt-users-modal-action='cancel'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              SUBMIT
            </button>
          </div>
        </form>
      </KTCardBody>
    </KTCard>
  )
}

export default InvoiceCreate
